<template>
  <div class="alertBox" :class="state?'alertBoxShow':''" v-if="state">
    <div class="alertBoxCont">
      {{text}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-alertBox',
    props: ['text'],
    data () {
      return {
        state: true
      }
    },
    mounted: function () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .alertBox {
    position: fixed;
    z-index: -100;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    .alertBoxCont {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) scale(0, 0);
      opacity: 0;
      background-color: #fff;
      text-align: center;
      line-height: 2rem;
      font-size: 1.25rem;
      padding: 1rem;
      color: #333;
      transition: 0.3s all;
      border-radius: 0.333rem;
      max-width: 75%;
      p {
        display: inline-block;
      }
    }
  }

  .alertBoxShow {
    z-index: 999;
    .alertBoxCont {
      transform: translate(-50%, -50%) scale(1, 1);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// alertBox.vue?7a670652